<template>
  <li>
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group">
          <label class="form-label hidden-lg">Type</label>

          <multiselect
            :options="containerOptions"
            :show-labels="false"
            label="name"
            track-by="type"
            v-model="type"
            v-bind="{ disabled }"
          />
        </div>
      </div>
      <div class="col-lg-2">
        <validation-provider tag="div" class="form-group" :vid="`containers.${index}.weight`" name="weight" v-slot="{ errors }">
          <label class="form-label hidden-lg">Weight</label>
          <input type="text" class="form-control text-right" v-model="weight" v-bind="{ disabled }" />

          <help-block v-bind="{ errors }" class="help-block text-danger" />
        </validation-provider>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <p class="strong form-label hidden-lg">Dimensions</p>
          <div class="row">
            <validation-provider tag="div" class="col-xs-4" :vid="`containers.${index}.width`" name="width" v-slot="{ errors }">
              <label class="form-label hidden-lg">Width</label>
              <div class="input-group readonly">
                <span class="input-group-addon">W</span>
                <input
                  type="text"
                  class="form-control text-right"
                  v-model="width"
                  v-bind="{ disabled }"
                />
              </div>

              <help-block v-bind="{ errors }" class="help-block text-danger" />
            </validation-provider>

            <validation-provider tag="div" class="col-xs-4" :vid="`containers.${index}.length`" name="length" v-slot="{ errors }">
              <label class="form-label hidden-lg">Length</label>
              <div class="input-group readonly">
                <span class="input-group-addon">L</span>
                <input
                  type="text"
                  class="form-control text-right"
                  v-model="length"
                  v-bind="{ disabled }"
                />
              </div>

              <help-block v-bind="{ errors }" class="help-block text-danger" />
            </validation-provider>

            <validation-provider tag="div" class="col-xs-4" :vid="`containers.${index}.height`" name="height" v-slot="{ errors }">
              <label class="form-label hidden-lg">Height</label>
              <div class="input-group readonly">
                <span class="input-group-addon">H</span>
                <input
                  type="text"
                  class="form-control text-right"
                  v-model="height"
                  v-bind="{ disabled }"
                />
              </div>

              <help-block v-bind="{ errors }" class="help-block text-danger" />
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="col-lg-12" v-if="container.consignment_id && container.article_id">
        <div class="row m-b-md m-t-xs text-muted">
          <div class="col-lg-4">
            <strong>Consignment</strong><br />
            {{ container.consignment_id }}
          </div>
          <div class="col-lg-4">
            <strong>Tracking</strong><br />
            <a :href="`https://auspost.com.au/mypost/track/#/details/${container.article_id}`" target="_blank">
              {{ container.article_id }}
            </a>
          </div>
          <div class="col-lg-4">
            <strong>Last Status</strong><br />
            {{ container.tracking_status }}
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <button
          type="button"
          class="btn btn-info btn-sm"
          style="margin-right: 0.75rem"
          data-toggle="modal"
          data-target="#modal-scan-into-run"
          :data-container="container.id"
        >
          <font-awesome :icon="['far', 'scanner-touchscreen']"/>
          Add to container
        </button>

        <button class="btn btn-sm" @click="toggleGarments">
          {{ garmentsVisible ? 'Hide' : 'Show' }} garments in container
        </button>
      </div>
      <div class="col-lg-12 collapse" :id="`container-${container.id}-garments`">
        <ul class="list-data no-links">
          <li class="data-heading visible-lg">
            <div class="row">
              <div class="col-md-4"><p>Firefighter</p></div>
              <div class="col-md-4"><p>Garment</p></div>
              <div class="col-md-4"><p>Serial</p></div>
            </div>
          </li>
          <li v-for="garment in container.garments" :key="garment.id">
            <div class="row">
              <div class="col-md-4"><p>{{ garment.firefighter }}</p></div>
              <div class="col-md-4"><p>{{ garment.name }}</p></div>
              <div class="col-md-4"><p>{{ garment.serial }}</p></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <button type="button" class="btn btn-sm text-danger btn-delete" @click="$emit('remove', index)" v-if="disabled === false">
      <font-awesome :icon="['far', 'trash-alt']" />
    </button>
  </li>
</template>

<script>
import $ from 'jquery'

export default {
  props: {
    index: Number,
    container: Object,
    disabled: Boolean,
    currentStop: Object
  },

  model: {
    prop: 'container'
  },

  data () {
    return {
      containerOptions: [
        { name: 'Satchel', type: 'satchel', length: 55, width: 45, height: 35 },
        { name: 'Box', type: 'box', length: 55, width: 45, height: 35 },
        { name: 'Custom', type: 'custom', length: null, width: null, height: null }
      ],
      garmentsVisible: false
    }
  },

  computed: {
    type: {
      get () {
        return this.containerOptions.find(({ type }) => this.container.type === type)
      },

      set ({ type }) {
        this.updateContainer({ type })
      }
    },

    weight: {
      get () {
        return this.container.weight
      },

      set (weight) {
        this.updateContainer({ weight })
      }
    },

    width: {
      get () {
        return this.container.width
      },

      set (width) {
        this.updateContainer({ width })
      }
    },

    length: {
      get () {
        return this.container.length
      },

      set (length) {
        this.updateContainer({ length })
      }
    },

    height: {
      get () {
        return this.container.height
      },

      set (height) {
        this.updateContainer({ height })
      }
    }
  },

  methods: {
    toggleGarments () {
      $(`#container-${this.container.id}-garments`).collapse('toggle')

      this.garmentsVisible = !this.garmentsVisible
    },

    updateContainer (values) {
      this.$emit('input', { ...this.container, ...values }, this.index)
    }
  }
}
</script>
